import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// Services
import { NavigationParam, RouteParam, ServiceBase } from '../../service-base';

// Modèles
import { RecurringInvoice } from 'src/app/@shared/models/sales/recurring-invoice/recurring-invoice.model';

const CLASS_NAME = 'RecurringInvoice';
const ENDPOINT = `/recurring-invoices/`;
const NAVIGATIONS: NavigationParam[] = [
    { key: 'invoices', path: 'invoices/', childClass: 'SalesInvoice' },
]
const ROUTES: RouteParam[] = [
    { key: 'activate', path: '{id}/activate/' },
    { key: 'deactivate', path: '{id}/deactivate/' },
    { key: 'massDelete', path: 'mass-delete/' },
]

@Injectable({
    providedIn: 'root'
})
export class RecurringInvoiceService extends ServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
        this.addNavigations(NAVIGATIONS);
        this.addRoutes(ROUTES);
    }

    public activate$(recurringInvoice: RecurringInvoice): Observable<RecurringInvoice> {
        let url = this.routes.activate.replace('{id}', recurringInvoice.id.toString());
        return this.update$(recurringInvoice, {
            url: url
        });
    }

    public deactivate$(recurringInvoice: RecurringInvoice): Observable<RecurringInvoice> {
        let url = this.routes.deactivate.replace('{id}', recurringInvoice.id.toString());
        return this.update$(recurringInvoice, {
            url: url
        });
    }
}
